import MoveEnv from './MoveEnv'

const customComponents = {
    "moveEnv" : {
        displayName: "Move Environments",
        component: MoveEnv
    }
}

export default customComponents;